import Button from "@/base-components/Button"
import Lucide from "@/base-components/Lucide"
import { useUserProfile } from "@/hooks/useUserProfile"
import { truncate } from "@/utils/constants"
import displayOdds from "@/utils/displayOdds"
import { readableDate, timeAgo } from "@/utils/helper"
import { useUser } from "@auth0/nextjs-auth0/client"
import clsx from "clsx"
import Link from "next/link"
import React from "react"

const index = ({ bet }) => {
  const { user, isLoading } = useUser()
  const { data: profile } = useUserProfile()

  return (
    <div
      className={clsx([
        "bg-dark-8 hover:cursor-pointer rounded-lg p-3 py-2 gradient-box",
        // matchIsPlaced(bet.match_id) ? "border border-purple" : "gradient-box",
      ])}
    >
      <div className="grid grid-cols-12 gap-1 border-b  border-white/[0.12] pb-2 my-2">
        <div className="col-span-12 blur-sm font-semibold text-sm">
          {/* {bet.event || `${bet?.teamA} vs ${bet?.teamB}`}
           */}
          Liverrpool vs Chelsea
        </div>

        <div className="col-span-7 !text-xs text-slate-600">
          {bet.sport_name} | {truncate(bet.country, 15)} |{" "}
          {truncate(bet.competition, 15)}
        </div>
        <div className="col-span-5  blur-sm  text-right text-xs">
          {/* {`${readableDate(bet.match_date, user.timezone)}`} */}
          Today May 19th 2030
        </div>
      </div>
      <div className="grid grid-cols-12 gap-2">
        <span className="flex flex-col text-sm font-regular mb-3 mt-1 col-span-3 ">
          <span className="font-semibold mr-2 !leading-5">EV%</span>
          <span className="!text-xs text-slate-600"> {`${bet.ev}%`}</span>
        </span>{" "}
        <span className="flex flex-col text-sm font-regular mb-3 mt-1 col-span-6">
          <span className="font-semibold mr-2 !leading-5 text-center">
            Market
          </span>
          <span className="!text-xs. blur-sm text-slate-600 text-center">
            market does here
          </span>
        </span>{" "}
        <span className="flex flex-col text-sm font-regular mb-3 mt-1 col-span-3 ">
          <span className="font-semibold  !leading-5 text-right">Odds</span>
          <span className="!text-xs text-slate-600 text-right">{bet.odds}</span>
        </span>{" "}
        <span className="flex flex-col text-sm font-regular mb-3 mt-1 col-span-3 ">
          <span className="font-semibold  !leading-5">Sportsbook</span>
          <span className="flex flex-col  justify-center  !text-xs text-slate-600">
            <span>{bet.bookmaker2}</span>
            {/* <div className="flex justify-center">
                            <img
                              className=" inline w-[30px] h-[30px] rounded-sm "
                              // src={`/images/bookmaker_logos/${el.bookmaker}.png`}
                              src={`https://oddsfantasyfrontendfiles.s3.amazonaws.com/bookmaker_logos/${bet.bookmaker2}.png`}
                              alt=""
                            />
                          </div> */}
          </span>
        </span>{" "}
        <span className="flex flex-col text-sm font-regular mb-3 mt-1 col-span-6 text-center">
          <span className="font-semibold mr-2 !leading-5">Bet</span>
          <span className="!text-xs  blur-sm  text-slate-600">
            bet goes here
          </span>
        </span>{" "}
        <span className="flex flex-col text-sm font-regular mb-3 mt-1 col-span-3 text-right">
          <span className="font-semibold !leading-5">Updated</span>
          <span className="!text-xs  blur-sm  text-slate-600">{`${timeAgo(bet.bet_age)}`}</span>
        </span>{" "}
      </div>
    </div>
  )
}

export default index
